import React, { useState } from 'react';
import {
  Modal, TouchableOpacity, Image, StyleSheet,
} from 'react-native';
import { VStack, HStack, Text, View } from 'native-base';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import TripPhotoSlot from './TripPhotoSlot';

const PHASES = [
  { key: 'BEFORE', label: 'Avant départ' },
  { key: 'AFTER', label: 'Après trajet' },
];

function TripPhotoGallery({ photos, onSlotPress, onRemovePhoto, readonly, editablePhase }) {
  const [lightboxSlot, setLightboxSlot] = useState(null); // full photo object

  const getPhoto = (phase, order) => photos?.find((p) => p.phase === phase && p.order === order);

  const handleRemove = () => {
    if (lightboxSlot && onRemovePhoto) {
      onRemovePhoto(lightboxSlot.id);
    }
    setLightboxSlot(null);
  };

  return (
    <VStack space={3}>
      {PHASES.map(({ key, label }) => {
        const isEditable = !readonly && (editablePhase ? editablePhase === key : true);
        return (
          <VStack key={key} space={1}>
            <Text fontSize="xs" color="gray.500" fontWeight="semibold">{label}</Text>
            <HStack space={2}>
              {[1, 2, 3, 4].map((order) => {
                const slot = getPhoto(key, order);
                return (
                  <TripPhotoSlot
                    key={order}
                    photo={slot?.photo ?? null}
                    readonly={!isEditable}
                    onPress={() => {
                      if (slot?.photo) {
                        setLightboxSlot(slot);
                      } else if (isEditable && onSlotPress) {
                        onSlotPress(key, order);
                      }
                    }}
                  />
                );
              })}
            </HStack>
          </VStack>
        );
      })}

      <Modal visible={!!lightboxSlot} transparent animationType="fade">
        <TouchableOpacity
          style={styles.lightboxBg}
          onPress={() => setLightboxSlot(null)}
          activeOpacity={1}
        >
          <Image
            source={{ uri: lightboxSlot?.photo }}
            style={styles.lightboxImage}
            resizeMode="contain"
          />
          <View style={styles.closeBtn}>
            <MaterialCommunityIcons name="close" size={24} color="white" />
          </View>
          {!readonly && onRemovePhoto && (!editablePhase || lightboxSlot?.phase === editablePhase) && (
            <TouchableOpacity style={styles.deleteBtn} onPress={handleRemove}>
              <MaterialCommunityIcons name="trash-can-outline" size={24} color="white" />
            </TouchableOpacity>
          )}
        </TouchableOpacity>
      </Modal>
    </VStack>
  );
}

const styles = StyleSheet.create({
  lightboxBg: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.9)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  lightboxImage: {
    width: '95%',
    height: '80%',
  },
  closeBtn: {
    position: 'absolute',
    top: 48,
    right: 20,
  },
  deleteBtn: {
    position: 'absolute',
    top: 48,
    left: 20,
    backgroundColor: 'rgba(239,68,68,0.8)',
    borderRadius: 8,
    padding: 6,
  },
});

export default TripPhotoGallery;
